export default "__VITE_ASSET__uRIZxn_G__"